/* Shorebird sections (sb-*) */
(function () {
  function sbMoney(cents, format) {
    var value = parseInt(cents, 10) || 0;
    var fmt = format || '${{amount}}';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    function delimit(precision, thousands, decimal) {
      var parts = (value / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var out;
    switch (key) {
      case 'amount_no_decimals': out = delimit(0, ',', '.'); break;
      case 'amount_with_comma_separator': out = delimit(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = delimit(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = delimit(2, "'", '.'); break;
      case 'amount_with_space_separator': out = delimit(2, ' ', ','); break;
      default: out = delimit(2, ',', '.');
    }
    return match ? fmt.replace(match[0], out) : out;
  }

  if (!customElements.get('sb-countdown')) {
    customElements.define('sb-countdown', class extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end || '');
        if (isNaN(this.end)) { this.hidden = true; return; }
        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = setInterval(this.tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        var diff = Math.max(0, this.end - Date.now());
        var total = Math.floor(diff / 1000);
        var units = { d: Math.floor(total / 86400), h: Math.floor((total % 86400) / 3600), m: Math.floor((total % 3600) / 60), s: total % 60 };
        for (var key in units) {
          var el = this.querySelector('[data-unit="' + key + '"]');
          if (el) el.textContent = String(units[key]).padStart(2, '0');
        }
        if (diff === 0) {
          clearInterval(this.timer);
          this.classList.add('is-ended');
          var target = this.closest('[data-sb-hide-on-end]');
          if (target) target.hidden = true;
        }
      }
    });
  }

  if (!customElements.get('sb-tabs')) {
    customElements.define('sb-tabs', class extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-sb-tab]'));
        this.buttons.forEach((btn) => {
          btn.addEventListener('click', () => this.select(btn.dataset.sbTab));
        });
      }
      select(name) {
        this.buttons.forEach((btn) => {
          var on = btn.dataset.sbTab === name;
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        this.querySelectorAll('[data-sb-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.sbPanel !== name;
        });
        this.setAttribute('data-view', name);
      }
    });
  }

  if (!customElements.get('sb-pair-builder')) {
    customElements.define('sb-pair-builder', class extends HTMLElement {
      connectedCallback() {
        this.slots = [null, null];
        this.format = this.dataset.moneyFormat;
        this.cheapestFree = this.dataset.cheapestFree === 'true';
        this.addEventListener('click', (event) => {
          var pick = event.target.closest('[data-sb-pick]');
          if (pick) { event.preventDefault(); this.pick(pick.closest('[data-sb-card]')); return; }
          var clear = event.target.closest('[data-sb-clear]');
          if (clear) { event.preventDefault(); this.slots[Number(clear.dataset.sbClear)] = null; this.render(); return; }
          var add = event.target.closest('[data-sb-add]');
          if (add) { event.preventDefault(); this.addToCart(add); }
        });
        this.render();
      }
      pick(card) {
        if (!card) return;
        var input = card.querySelector('[data-sb-variant]');
        if (!input) return;
        var option = input.tagName === 'SELECT' ? input.options[input.selectedIndex] : input;
        if (!option || option.disabled) return;
        var item = {
          id: Number(option.value),
          price: Number(option.dataset.price),
          title: card.dataset.title || '',
          variant: option.dataset.variantTitle || '',
          image: card.dataset.image || ''
        };
        this.slots[this.slots[0] === null ? 0 : 1] = item;
        this.render();
        var bar = this.querySelector('[data-sb-slots]');
        if (bar && bar.getBoundingClientRect().top < 0) bar.scrollIntoView({ block: 'nearest' });
      }
      render() {
        var self = this;
        this.slots.forEach(function (item, i) {
          var slot = self.querySelector('[data-sb-slot="' + i + '"]');
          if (!slot) return;
          var img = slot.querySelector('[data-sb-slot-img]');
          var title = slot.querySelector('[data-sb-slot-title]');
          var meta = slot.querySelector('[data-sb-slot-meta]');
          slot.classList.toggle('is-filled', !!item);
          img.innerHTML = '';
          if (item) {
            if (item.image) {
              var el = document.createElement('img');
              el.src = item.image;
              el.alt = '';
              el.loading = 'lazy';
              img.appendChild(el);
            }
            title.textContent = item.title;
            meta.textContent = (item.variant ? item.variant + ' · ' : '') + sbMoney(item.price, self.format);
          } else {
            title.textContent = slot.dataset.emptyTitle || '';
            meta.textContent = slot.dataset.emptyMeta || '';
          }
        });
        var filled = this.slots.filter(Boolean);
        var total = filled.reduce(function (sum, it) { return sum + it.price; }, 0);
        var saving = this.cheapestFree && filled.length === 2 ? Math.min(filled[0].price, filled[1].price) : 0;
        var totalEl = this.querySelector('[data-sb-total]');
        if (totalEl) {
          totalEl.innerHTML = '';
          if (filled.length) {
            if (saving) {
              var was = document.createElement('s');
              was.textContent = sbMoney(total, this.format);
              totalEl.appendChild(was);
            }
            var now = document.createElement('strong');
            now.textContent = sbMoney(total - saving, this.format);
            totalEl.appendChild(now);
          }
        }
        var count = this.querySelector('[data-sb-count]');
        if (count) count.textContent = filled.length;
        var addBtn = this.querySelector('[data-sb-add]');
        if (addBtn) addBtn.disabled = filled.length < 2;
      }
      addToCart(btn) {
        var items = this.slots.filter(Boolean).map(function (it) { return { id: it.id, quantity: 1 }; });
        if (items.length < 2) return;
        var errorEl = this.querySelector('[data-sb-error]');
        if (errorEl) errorEl.hidden = true;
        btn.disabled = true;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            return res.json().then(function (data) { if (!res.ok) throw data; return data; });
          })
          .then(function () {
            window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
          })
          .catch(function (err) {
            btn.disabled = false;
            if (errorEl) {
              errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
              errorEl.hidden = false;
            }
          });
      }
    });
  }

  if (!customElements.get('sb-hotspots')) {
    customElements.define('sb-hotspots', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          var dot = event.target.closest('[data-sb-dot]');
          if (!dot) return;
          var spot = dot.closest('[data-sb-spot]');
          var opening = !spot.classList.contains('is-open');
          this.closeAll();
          if (opening) { spot.classList.add('is-open'); dot.setAttribute('aria-expanded', 'true'); }
        });
        this.onDocClick = (event) => { if (!this.contains(event.target)) this.closeAll(); };
        document.addEventListener('click', this.onDocClick);
      }
      disconnectedCallback() { document.removeEventListener('click', this.onDocClick); }
      closeAll() {
        this.querySelectorAll('[data-sb-spot].is-open').forEach(function (spot) {
          spot.classList.remove('is-open');
          var dot = spot.querySelector('[data-sb-dot]');
          if (dot) dot.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  if (!customElements.get('sb-gift-finder')) {
    customElements.define('sb-gift-finder', class extends HTMLElement {
      connectedCallback() {
        this.state = {};
        this.addEventListener('click', (event) => {
          var chip = event.target.closest('[data-sb-chip]');
          if (!chip) return;
          var question = chip.dataset.sbQ;
          var value = chip.dataset.sbChip;
          this.state[question] = this.state[question] === value ? null : value;
          this.querySelectorAll('[data-sb-q="' + question + '"]').forEach((el) => {
            var on = el.dataset.sbChip === this.state[question];
            el.classList.toggle('is-active', on);
            el.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          this.filter();
        });
      }
      filter() {
        var state = this.state;
        var shown = 0;
        this.querySelectorAll('[data-sb-gift]').forEach(function (gift) {
          var ok = ['who', 'level', 'budget'].every(function (q) {
            if (!state[q]) return true;
            var val = gift.dataset[q];
            return val === 'any' || val === state[q];
          });
          gift.hidden = !ok;
          if (ok) shown++;
        });
        var empty = this.querySelector('[data-sb-empty]');
        if (empty) empty.hidden = shown > 0;
      }
    });
  }

  if (!customElements.get('sb-fit-finder')) {
    customElements.define('sb-fit-finder', class extends HTMLElement {
      connectedCallback() {
        this.sizeSelect = this.querySelector('[data-sb-size]');
        this.output = this.querySelector('[data-sb-fit-out]');
        if (!this.sizeSelect || !this.output) return;
        this.addEventListener('change', () => this.update());
        this.update();
      }
      update() {
        var sizes = Array.prototype.map.call(this.sizeSelect.options, function (o) { return o.value; }).filter(Boolean);
        var current = this.sizeSelect.value;
        var style = this.querySelector('[data-sb-style]:checked');
        if (!current || !style) { this.output.hidden = true; return; }
        var index = sizes.indexOf(current);
        var recommended = current;
        var message = this.dataset.tailored || '';
        if (style.value === 'relaxed') {
          if (index > -1 && index < sizes.length - 1) {
            recommended = sizes[index + 1];
            message = this.dataset.relaxed || '';
          } else {
            message = this.dataset.relaxedMax || '';
          }
        }
        this.output.textContent = message.replace(/\[size\]/g, recommended);
        this.output.hidden = false;
      }
    });
  }
})();